<hw-page-header header="term.cs-02.header" class="page-header" (onBack)="goBack()">
  <button (click)="save()" class="float-right" nz-button nzType="primary">{{ 'core.btn.save' | translate }}</button>
</hw-page-header>

<nz-content class="main" *ngIf="codeSystem">
  <form nz-form #form="ngForm">
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="id" [required]="true" label="term.cs-02.id">
          <input nz-input name="id" [(ngModel)]="codeSystem.id" [disabled]="!isNew" required />
        </hw-form-item>
      </div>
    </hw-form-row>
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="names" [required]="true" label="term.cs-02.names">
          <hw-multilang-input name="names" [(ngModel)]="codeSystem.names" required></hw-multilang-input>
        </hw-form-item>
      </div>
    </hw-form-row>
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="title" label="term.cs-02.description">
          <hw-multilang-input name="title" [(ngModel)]="codeSystem.title"></hw-multilang-input>
        </hw-form-item>
      </div>
    </hw-form-row>
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="behavior" label="term.cs-02.behavior">
          <nz-select name="behavior" [(ngModel)]="codeSystem.behavior" [disabled]="!isNew">
            <nz-option *ngFor="let o of ['temporal', 'unique']" [nzLabel]="o" [nzValue]="o"></nz-option>
          </nz-select>
        </hw-form-item>
      </div>
    </hw-form-row>
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="url" label="term.cs-02.url">
          <input nz-input [(ngModel)]="codeSystem.url" name="url" />
        </hw-form-item>
      </div>
    </hw-form-row>
  </form>

  <hw-table header="term.cs-02.system-attributes">
    <nz-table
      #basicTable
      [nzData]="[
        { id: 'id', datatype: 'text', required: true },
        { id: 'names', datatype: 'translation' },
        { id: 'validFrom', datatype: 'date' },
        { id: 'validTo', datatype: 'date' },
        { id: 'parent', datatype: 'codesystem' }
      ]"
      nzSize="small"
      nzHideOnSinglePage="true"
      nzShowSizeChanger="false">
      <thead>
        <tr>
          <th>{{ 'term.cs-02.visible' | translate }}</th>
          <th>{{ 'term.cs-02.id' | translate }}</th>
          <th>{{ 'term.cs-02.type' | translate }}</th>
          <th>{{ 'term.cs-02.required' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of basicTable.data">
          <td>
            <input
              *ngIf="row.id !== 'id'"
              type="checkbox"
              name="${{ row.id }}_visible"
              (change)="toggleHidden(row.id)"
              [checked]="codeSystem.notes?.hidden ? codeSystem.notes.hidden.indexOf(row.id) == -1 : true" />
            <i nz-icon nzType="check" nzTheme="outline" *ngIf="row.id === 'id'"></i>
          </td>
          <td>{{ row.id }}</td>
          <td>{{ row.datatype }}</td>
          <td><i nz-icon nzType="check" nzTheme="outline" *ngIf="row.required"></i></td>
        </tr>
      </tbody>
    </nz-table>
  </hw-table>

  <form #attributeForm="ngForm" class="row-table">
    <hw-flex-editable-table
      #table
      [validateOnFocus]="false"
      [data]="codeSystem.attributes"
      [rowInstance]="defaultRow"
      [header]="'term.cs-02.attributes'"
      [form]="attributeForm">
      <hw-flex-editable-column title="{{ 'term.cs-02.attrs.id' | translate }}" name="id">
        <ng-template #viewTemplate let-item>
          {{ item.id }}
        </ng-template>
      </hw-flex-editable-column>

      <hw-flex-editable-column title="{{ 'term.cs-02.attrs.name' | translate }}" name="name">
        <ng-template #viewTemplate let-item>
          {{ item.names | localName }}
        </ng-template>
      </hw-flex-editable-column>

      <hw-flex-editable-column title="{{ 'term.cs-02.attrs.type' | translate }}" name="type">
        <ng-template #viewTemplate let-item>
          {{ item.datatype }}
        </ng-template>
      </hw-flex-editable-column>

      <hw-flex-editable-column title="{{ 'term.cs-02.attrs.required' | translate }}" name="required">
        <ng-template #viewTemplate let-item>
          <i nz-icon nzType="check" nzTheme="outline" *ngIf="item.required"></i>
        </ng-template>
      </hw-flex-editable-column>

      <hw-flex-editable-column title="{{ 'term.cs-02.attrs.default' | translate }}" name="default">
        <ng-template #viewTemplate let-item>
          <ng-container *ngIf="item.datatype === 'translations'">
            {{ item.defaultValue | localName }}
          </ng-container>
          <ng-container *ngIf="item.datatype !== 'translations'"> {{ item.defaultValue }}` </ng-container>
        </ng-template>
      </hw-flex-editable-column>

      <ng-template #expandEditTemplate let-item>
        <ng-container *ngIf="item">
          <div hw-form-row>
            <div *hw-form-col>
              <hw-form-item name="id" label="{{ 'term.cs-02.attrs.id' | translate }}" required>
                <input nz-input name="id" [(ngModel)]="item.id" required />
              </hw-form-item>

              <hw-form-item name="names" label="{{ 'term.cs-02.attrs.name' | translate }}">
                <hw-multilang-input name="names" [(ngModel)]="item.names"></hw-multilang-input>
              </hw-form-item>

              <hw-form-item name="required" label="{{ 'term.cs-02.attrs.required' | translate }}">
                <input nz-input type="checkbox" name="required" [(ngModel)]="item.required" />
              </hw-form-item>

              <hw-form-item name="type" label="{{ 'term.cs-02.attrs.type' | translate }}" required>
                <nz-select
                  name="type"
                  nzShowSearch
                  [(ngModel)]="item.datatype"
                  (ngModelChange)="onAttrTypeChange(item)"
                  required>
                  <nz-option *ngFor="let o of attrTypes" [nzLabel]="o" [nzValue]="o"></nz-option>
                </nz-select>
              </hw-form-item>

              <hw-form-item name="length" label="term.cs-02.attrs.length" *ngIf="item.datatype === 'text'">
                <input nz-input name="length" [(ngModel)]="item.parameters['length']" />
              </hw-form-item>
              <hw-form-item name="range" label="term.cs-02.attrs.range" *ngIf="item.datatype === 'number'">
                <input nz-input name="range" [(ngModel)]="item.parameters['range']" />
              </hw-form-item>
              <hw-form-item
                name="codesystem"
                label="term.cs-02.attrs.codesystem"
                *ngIf="item.datatype === 'codesystem'">
                <hw-term-codesystem-select
                  name="codesystem"
                  [showSearch]="true"
                  [(ngModel)]="item.parameters['codesystem']"></hw-term-codesystem-select>
              </hw-form-item>
              <hw-form-item
                name="dictionary"
                label="term.cs-02.attrs.dictionary"
                *ngIf="item.datatype === 'dictionary'">
                <hw-term-dictionary-select
                  name="dictionary"
                  [(ngModel)]="item.parameters['dictionary']"></hw-term-dictionary-select>
              </hw-form-item>

              <hw-form-item name="default" label="{{ 'term.cs-02.attrs.default' | translate }}">
                <hw-term-attribute-input
                  [(ngModel)]="item.defaultValue"
                  [attribute]="item"
                  name="default"></hw-term-attribute-input>
              </hw-form-item>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </hw-flex-editable-table>
  </form>
</nz-content>
